import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@icons/check_disabled.png'
import _imports_1 from '@icons/check.png'


const _hoisted_1 = { class: "divItemInfo" }
const _hoisted_2 = {
  key: 0,
  class: "image-icon"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Check",
  class: "imgCheck",
  "data-testid": "imgCheckSelected"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "image-icon"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Check",
  class: "imgCheck",
  "data-testid": "imgCheckInSelection"
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["data-select-filter"]
const _hoisted_9 = { class: "lblCount" }
const _hoisted_10 = { class: "rightContent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sc_image = _resolveComponent("sc-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["facet-list-item", { 'filter-disabled': _ctx.isCheckboxDisabled }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isCheckboxDisabled && _ctx.isSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : (_ctx.isSelected || _ctx.isInSelection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "leftContent", {}, () => [
          _createElementVNode("span", {
            "data-select-filter": _ctx.item.name
          }, _toDisplayString(_ctx.item.name) + " ", 9, _hoisted_8),
          _createElementVNode("span", _hoisted_9, "(" + _toDisplayString(_ctx.item.value) + ")", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _renderSlot(_ctx.$slots, "rightContent", {}, () => [
          (_ctx.item.scImage)
            ? (_openBlock(), _createBlock(_component_sc_image, {
                key: 0,
                media: _ctx.item.scImage,
                class: _normalizeClass([{
              inSelection:
                _ctx.isInSelection &&
                _ctx.filterType !== _ctx.facetMetaData.extcolor.key &&
                _ctx.filterType !== _ctx.facetMetaData.intcolor.key,
            }, "sc-image float-right"]),
                loading: "lazy"
              }, null, 8, ["media", "class"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}